/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ComponentTest = {
  /**
   * * `success` - Success
   * * `failed` - Failed
   */
  status: ComponentTest.status
  output: Record<string, any> | null
}
export namespace ComponentTest {
  /**
   * * `success` - Success
   * * `failed` - Failed
   */
  export enum status {
    SUCCESS = "success",
    FAILED = "failed",
  }
}
